import { useEffect } from 'react';
import { useSplitClient } from '@splitsoftware/splitio-react';

import { BRANDS, FEATURE_FLAG } from 'constants/featureFlags/boysenberrySignup';
import useGlobalStore from 'hooks/useGlobalStore';
import { trackExperimentAssignment } from 'utils/analyticsUtils';
import { getAnonymousId } from 'utils/globalUtils';

/**
 * Returns Split data for the `boysenberry-signup` experiment.
 * This experiment should always be keyed off of the user's anoynmous id in order
 * to maintain a consistent experience between logged-out and logged-in states
 * [on the same device].
 *
 * @returns {Object} The user's Split data.
 */
const useBoysenberrySignupFlag = () => {
    const { isMisfitsTheme } = useGlobalStore();
    const {
        client: splitClient,
        isReady: splitIsReady,
        isTimedout: splitIsTimedout,
    } = useSplitClient({ splitKey: getAnonymousId() });

    const splitTreatment = splitClient?.getTreatments([FEATURE_FLAG], {
        brand: isMisfitsTheme ? BRANDS.misfitsMarket : BRANDS.imperfectFoods,
    })?.[FEATURE_FLAG];

    useEffect(() => {
        if (splitIsReady && !splitIsTimedout) {
            trackExperimentAssignment({
                experiment: FEATURE_FLAG,
                variation: splitTreatment,
                trackEvent: true,
            });
        }
    }, [splitIsReady, splitIsTimedout, splitTreatment]);

    return {
        isReady: splitIsReady,
        key: splitClient?.key,
        treatment: splitTreatment,
    };
};

export { useBoysenberrySignupFlag };
